import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-generic-chart',
	styleUrls: ['./generic-chart.component.css'],
	templateUrl: './generic-chart.component.html'
})
export class UiKitChartComponent implements OnInit, OnChanges {
	@Input() configuration: object;
	@Input() colorPalette: object;
	@Input() data: any[];

	public chartConfig: object;
	public chartData: any[];

	constructor() {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.configuration || this.data) {
			this.chartConfig = this.configuration;
			this.chartData = this.data;
			this.colorPalette = this.colorPalette;
		}
	}
}
